/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Payload for per-MCP-server tool-call activity used by the Distribute MCP listing indicators
 */
export type GetMcpServerActivityPayload = {
  /**
   * Size of the recent-activity window in days. A server with tool calls in the overall lookback window but none inside this window is flagged as stale. Defaults to 14.
   */
  recentWindowDays?: number | undefined;
};

/** @internal */
export type GetMcpServerActivityPayload$Outbound = {
  recent_window_days: number;
};

/** @internal */
export const GetMcpServerActivityPayload$outboundSchema: z.ZodMiniType<
  GetMcpServerActivityPayload$Outbound,
  GetMcpServerActivityPayload
> = z.pipe(
  z.object({
    recentWindowDays: z._default(z.int(), 14),
  }),
  z.transform((v) => {
    return remap$(v, {
      recentWindowDays: "recent_window_days",
    });
  }),
);

export function getMcpServerActivityPayloadToJSON(
  getMcpServerActivityPayload: GetMcpServerActivityPayload,
): string {
  return JSON.stringify(
    GetMcpServerActivityPayload$outboundSchema.parse(
      getMcpServerActivityPayload,
    ),
  );
}
